module.exports = __webpack_public_path__ + "media/assets/services_manager/lock-80ccc57a847944a60537307582f14f78a6fa7262c695e66bda1e44e2569655c6.svg";